<template>&nbsp;<i class="pi pi-info-circle" v-tooltip="{ value: description }" /></template>

<script>
export default {
    props: ['description'],
};
</script>
